import type { FilterType, GlobalFilter } from '@hotjar/global-filters';
import { FilterKindEnum, LargeListFilterOperation } from '@hotjar/global-filters';
import { v4 as generateUUID } from 'uuid';
import { parseCountryList } from '@hotjar/feedback/domain/common/Responses/Filters/Query/GlobalFilterQuery/parseCountryList';
import { parseDateRange } from '@hotjar/feedback/domain/common/Responses/Filters/Query/GlobalFilterQuery/parseDateRange';
import { parseUserAttribute } from './parseUserAttribute';
import { parseDeviceList } from '../../../../../common/Responses/Filters/Query/GlobalFilterQuery/parseDeviceList';

function* parseFilterList(params: URLSearchParams): Generator<FilterType> {
  for (const param of params.getAll('device')) {
    const deviceList = parseDeviceList(param);
    if (deviceList.length === 0) continue;
    yield {
      id: generateUUID(),
      kind: FilterKindEnum.DeviceType,
      value: deviceList,
    };
  }

  for (const param of params.getAll('country')) {
    const countryList = parseCountryList(param);
    if (countryList.length === 0) continue;
    yield {
      id: generateUUID(),
      kind: FilterKindEnum.Country,
      value: {
        selectedValues: countryList,
        operation: LargeListFilterOperation.IS_ANY_OF_THESE,
      },
    };
  }

  for (const param of params.getAll('country_not')) {
    const countryList = parseCountryList(param);
    if (countryList.length === 0) continue;
    yield {
      id: generateUUID(),
      kind: FilterKindEnum.Country,
      value: {
        selectedValues: countryList,
        operation: LargeListFilterOperation.IS_NONE_OF_THESE,
      },
    };
  }

  for (const param of params.getAll('user_attribute')) {
    const userAttribute = parseUserAttribute(param);
    if (userAttribute === undefined) continue;
    yield {
      id: generateUUID(),
      kind: FilterKindEnum.UserAttribute,
      value: userAttribute,
    };
  }
}

export const convertSearchParamsToGlobalFilters = (params: URLSearchParams): GlobalFilter => {
  return {
    dateRange: parseDateRange(params),
    filterList: [...parseFilterList(params)],
  };
};
